export const UMB_EXTENSION_ENTITY_TYPE = 'extension';

export type UmbExtensionEntityType = typeof UMB_EXTENSION_ENTITY_TYPE;
